import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { BrandInsightsCapabilities } from '@trinity/chat';
import type { MicState } from '@trinity/chat-components/containers/TextToSpeechAudioPlayer/Context.js';
import { createNamedContext } from '@trinity/chat-components/utils/react';
import type { ILink } from './interfaces';

type SideBarExpandedContextValue = [boolean, Dispatch<SetStateAction<boolean>>];
type SidePanelExpandedContextValue = [boolean, Dispatch<SetStateAction<boolean>>];

export type AuraChatContextType = {
  canToggleAuraChat: boolean;
  auraChatStatus: boolean;
  setAuraChatStatus: Dispatch<SetStateAction<boolean>>;
};

export const SideBarExpandedContext = createContext<SideBarExpandedContextValue>(null);
export const SidePanelExpandedContext = createContext<SidePanelExpandedContextValue>(null);
export const BrandInsightsModalContext = createContext<Modal.ToggleContext>([false, () => {}]);
export const InputControlsContext = createNamedContext<InputControlsContextValue>(
  undefined,
  'InputControls.Context'
);
export const LinkContext = createContext<ILink.LinkContextValue>(undefined);
export const LinkDispatchContext = createContext<Dispatch<ILink.Action>>(undefined);
export const ChatViewTypeContext = createContext<ChatViewType>(undefined);
export const CapabilitiesContext = createContext<BrandInsightsCapabilities>({
  canApplyFilters: false,
  canViewTraces: false,
  canViewExternalLinks: false,
  canViewMetadata: false,
});
export const AuraChatContext = createContext<AuraChatContextType>({
  canToggleAuraChat: false,
  auraChatStatus: false,
  setAuraChatStatus: () => {},
});

export declare namespace Modal {
  export type ToggleContext = [isOpen: boolean, toggleModal: () => void];
}

export enum ChatViewType {
  Modal = 'modal',
  Page = 'page',
}

type SpeechRecognitionContextValue = {
  errorMsg: string;
  interimResult: string;
  isSupported: () => boolean;
  listening: boolean;
  micState: MicState;
  start: (prefix?: string) => void;
  stop: (debug: unknown) => Promise<void>;
};

type InputControlsContextValue = {
  onClickMicrophone: () => void;
  onClickSubmit: () => void;
  onClickVoiceMode: () => void;
  soundLevelRef: React.RefObject<HTMLDivElement>;
  speechRecognition: SpeechRecognitionContextValue;
  textAreaRef: React.RefObject<HTMLTextAreaElement>;
};
